module.exports = __webpack_public_path__ + "img/icon_dban_zh.351bc963.png";